import {PinProtect} from '~/features/Auth/PinProtect';
import {ParentLookup} from '~/features/ParentPay';

export const ParentLookupScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <ParentLookup />
      </PinProtect>
    </div>
  );
};
